/**
 * Created by mark on 11/12/2017.
 */

import React from "react";
import { Row } from "react-bootstrap";
import { loadStripe } from "@stripe/stripe-js";

export default class Authentication extends React.Component {
  constructor(props) {
    super();
    this.props = props;
    this.state = {};
  }

  async componentDidMount() {
    const stripePromise = loadStripe('pk_live_pTdLrLzpfvyOg1ZAKbq4XHEa');
    //const stripePromise = loadStripe('pk_test_14ng1mayzzrl7tCJJrxwxyym');
    
    
    const stripe = await stripePromise;

    var checkoutButton = document.getElementById(
      "checkout-button-sku_GvtTrsQ8OoS3UW"
    );
    checkoutButton.addEventListener("click", function () {
      // When the customer clicks on the button, redirect
      // them to Checkout.
      stripe
        .redirectToCheckout({
          items: [{ sku: "sku_GvtTrsQ8OoS3UW", quantity: 1 }],

          // Do not rely on the redirect to the successUrl for fulfilling
          // purchases, customers may not always reach the success_url after
          // a successful payment.
          // Instead use one of the strategies described in
          // https://stripe.com/docs/payments/checkout/fulfillment
          successUrl: "https://www.languagenut.com/home/#/success",
          cancelUrl: "https://www.languagenut.com/home/#/",
        })
        .then(function (result) {
          if (result.error) {
            // If `redirectToCheckout` fails due to a browser or network
            // error, display the localized error message to your customer.
            var displayError = document.getElementById("error-message");
            displayError.textContent = result.error.message;
          }
        });
    });

    var secondaryButton = document.getElementById(
      "checkout-button-sku_GvtZwMbPccDP3T"
    );
    secondaryButton.addEventListener("click", function () {
      // When the customer clicks on the button, redirect
      // them to Checkout.
      stripe
        .redirectToCheckout({
          items: [{ sku: "sku_GvtZwMbPccDP3T", quantity: 1 }],

          // Do not rely on the redirect to the successUrl for fulfilling
          // purchases, customers may not always reach the success_url after
          // a successful payment.
          // Instead use one of the strategies described in
          // https://stripe.com/docs/payments/checkout/fulfillment
          successUrl: "https://www.languagenut.com/home/#/success",
          cancelUrl: "https://www.languagenut.com/home/#/",
        })
        .then(function (result) {
          if (result.error) {
            // If `redirectToCheckout` fails due to a browser or network
            // error, display the localized error message to your customer.
            var displayError = document.getElementById("error-message");
            displayError.textContent = result.error.message;
          }
        });
    });
  }

  render() {
    return (
      <div>
        <Row>
          <div class="col-lg-1"></div>
          <div class="col-lg-10">
            <center>
              <img
                height="100px"
                src="https://s3-eu-west-1.amazonaws.com/marketing.languagenut.com/Sales%20site/Languagenut%20Sales%20Sites%20Image%20Assets/LN%20Logo.png"
              />
            </center>
          </div>
        </Row>
        <br />
        <Row>
          <div class="col-lg-1"></div>
          <div class="row d-flex justify-content-center"  style={{display:"flex", flexWrap:"wrap"}}>
          <div class="card col-lg-5" style={{marginRight:"50px"}}>
          <div class="card-body" style={{display:"flex", justifyContent:"space-between", flexDirection:"column"}}>
                <center>
                  <img height="150px" src="./img/primary-el.png" />
                </center>
                <hr />
                <ul class="fa-ul">
                  <li><span class="fa-li"><i class="fas fa-check"></i></span>Personal account for one learner</li>
                  <li><span class="fa-li"><i class="fas fa-check"></i></span>Access to 25+ world languages, including French, Spanish and German</li>
                  <li><span class="fa-li"><i class="fas fa-check"></i></span>Carefully curated beginner vocabulary and high-frequency language</li>
                  <li><span class="fa-li"><i class="fas fa-check"></i></span>Interactive activities covering listening, speaking, reading and writing</li>
                  <li><span class="fa-li"><i class="fas fa-check"></i></span>Engaging games designed to build confidence and fluency</li>
                  <li><span class="fa-li"><i class="fas fa-check"></i></span>Grammar and verb practice presented in an accessible way</li>
                  <li><span class="fa-li"><i class="fas fa-check"></i></span>Sentence-building activities to develop communication skills</li>
                  <li><span class="fa-li"><i class="fas fa-check"></i></span>Phonics and pronunciation exercises to support accurate speaking</li>
                </ul>
                <div style={{display:"flex", alignItems:"center"}}>
                  <a
                    id="checkout-button-sku_GvtTrsQ8OoS3UW"
                    role="link"
                    class="btn btn-block btn-primary text-uppercase"
                    style={{display:"flex", justifyContent:"center", width:"90%", margin:"auto"}}
                  >Buy Now</a>
          </div>
          </div>
          </div>
          <div class="card col-lg-5">
              <div class="card-body">
                <center>
                  <img height="150px" src="./img/secondary-hi.png" />
                </center>
                <hr />
                <ul class="fa-ul">
                  <li><span class="fa-li"><i class="fas fa-check"></i></span>Licence for a Single User</li>
                  <li><span class="fa-li"><i class="fas fa-check"></i></span>Personal account for one learner</li>
                  <li><span class="fa-li"><i class="fas fa-check"></i></span>Available for French, Spanish, German, Italian, Arabic & Urdu</li>
                  <li><span class="fa-li"><i class="fas fa-check"></i></span>Thousands of revision tasks and exam questions</li>
                  <li><span class="fa-li"><i class="fas fa-check"></i></span>Extensive intermediate and advanced vocabulary resources</li>
                  <li><span class="fa-li"><i class="fas fa-check"></i></span>30+ interactive games across all four language skills</li>
                  <li><span class="fa-li"><i class="fas fa-check"></i></span>Dynamic verb conjugation practice across multiple tenses</li>
                  <li><span class="fa-li"><i class="fas fa-check"></i></span>Structured sentence-building activities to develop accuracy and fluency</li>
                  <li><span class="fa-li"><i class="fas fa-check"></i></span>Pronunciation and phonics activities to strengthen speaking confidence</li>
                  <li><span class="fa-li"><i class="fas fa-check"></i></span>Aligned with secondary and high school language curricula worldwide</li>
                </ul>
                <div style={{display:"flex", alignItems:"center"}}>
                <a
                  href="#"
                  id="checkout-button-sku_GvtZwMbPccDP3T"
                  role="link"
                  class="btn btn-block btn-primary text-uppercase"
                  style={{display:"flex", justifyContent:"center", width:"90%", margin:"auto"}}
                >
                  Buy Now
                </a>
                </div>
            </div>
          </div>
          </div>
          <div id="error-message"></div>
        </Row>
      </div>
    );
  }
}
